import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-seq-step-condition",
  "use": "icon-seq-step-condition-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-seq-step-condition\">\n<path d=\"M15.8438 7.71875C20.7188 7.71875 23.1562 10.1562 23.1562 13C23.1562 15.8438 20.7188 18.2812 15.8438 18.2812M9.34375 13H16.6562M10.1562 7.71875C5.28125 7.71875 2.84375 10.1562 2.84375 13C2.84375 15.8438 5.28125 18.2812 10.1562 18.2812\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol